export default __webpack_public_path__ + "static/media/plaque.fc8c57ec.png";